export class StockFunds {
  id: string;
  positionDate: string;
  positions: StockFundsPosition[]; //à vista
  marketPositions: StockFundMarketPosition[];
}

export class StockFundsPosition {
  institutionName: string;
  fundName: string;
  fundSourceId: string;
  quotaValue: number;
  netValue: number;
  availableQuantity: number;
}

export class StockFundMarketPosition {
  institutionName: string;
  fundSourceId: string;
  availableQuantity: number;
  result: number;
  totalCost: number;
  netValue: number;
}
